// extracted by mini-css-extract-plugin
export default {"dlScreenInfoMessage":"src-js-containers-auto_layout-components-ScreenInfoMessage---dlScreenInfoMessage---KsWTm"};